import { nonNullable } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsInsurnaceDomesticTrip from './getIsInsurnaceDomesticTrip'
import { getInsuranceProductListKey } from 'lib/insurance/insuranceUtils'

const getCheckoutInsuranceProducts = createSelector(
  (state: App.State) => getIsInsurnaceDomesticTrip(state),
  (state: App.State) => state.insurance.productLists,
  (state: App.State) => state.insurance.products,
  (_: App.State, type?: App.InsuranceProductType) => type,
  (isDomestic, productLists, products, type): Array<App.InsuranceProduct> => {
    const key = getInsuranceProductListKey(type ?? 'travel-insurance', {
      isDomestic,
      isCruise: false,
    })

    const list = productLists[key]
    return nonNullable(list?.map(id => products[id]) ?? [])
  },
)

export default getCheckoutInsuranceProducts
